import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import ButtonStatus from 'components/buttons/ButtonStatus';

const useStyles = makeStyles()((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: `linear-gradient(45deg, ${darken('#5721E5', 0.2)} 0%, #5721E5 20%, ${darken(
      '#8C21E5',
      0.1,
    )}  100%)`,

    '@media print': {
      display: 'none !important',
    },
  },

  flexGrow: {
    flexGrow: 1,
  },

  logo: {
    width: '50px',
    borderRadius: '50%',
  },
  name: {
    color: '#ffffffd4',
    padding: '0px 10px',
    marginBottom: '5px',
    fontSize: '16px',
    fontWeight: 'bold',
  },
}));

// COMPONENT
function PrintTopbar({ className, onToggleMenu, open }) {
  const { classes } = useStyles();

  return (
    <AppBar position="absolute" className={classes.appBar}>
      <Toolbar>
        <RouterLink to="/">
          <img alt="Logo" src="/images/logos/minha-agenda-logo-white-small.png" className={classes.logo} />
        </RouterLink>
        <RouterLink to="/">
          <Typography className={classes.name} variant="h6">
            MinhaAgenda
          </Typography>
        </RouterLink>
        <div className={classes.flexGrow} />

        <div>
          <ButtonStatus
            status="success"
            variant="contained"
            onClick={() => {
              window.print();
            }}
          >
            Imprimir
          </ButtonStatus>
          <Button
            variant="contained"
            style={{ marginLeft: '25px' }}
            onClick={() => {
              window.close();
            }}
          >
            Fechar
          </Button>
        </div>
        {/* LEFT SIDE */}
      </Toolbar>
    </AppBar>
  );
}

export default PrintTopbar;
